import { Box, Heading, Text } from '@zillow/constellation-10';

import { BankSVGComponent, CreditCardLeftSVGComponent, CreditCardRightSVGComponent } from './LandingPageSvgs';

const CostToPay = () => {
  const renderIcon = ({ IconComponent }) => <IconComponent size={40} />;

  const renderRow = ({ IconComponent, header, price }) => (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        paddingBottom: 'default',
        marginBottom: 'default',
        borderBottom: '1px solid #d1d1d1',
      }}
    >
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'tighter' }}>
        {renderIcon({ IconComponent })}
        <Text textStyle="body-bold">{header}</Text>
      </Box>
      <Box css={{ alignContent: 'flex-end' }}>{price}</Box>
    </Box>
  );
  return (
    <Box css={{ textAlign: 'center', padding: '60px 16px' }}>
      <Heading level={2} textStyle="heading-sm" css={{ textAlign: 'center', marginBottom: 'default' }}>
        Does it cost anything to pay my rent online?
      </Heading>
      <Box css={{ margin: 'auto', maxWidth: '500px' }}>
        {renderRow({
          IconComponent: BankSVGComponent,
          header: 'Bank transfer',
          price: <Text textStyle="body-bold">Free</Text>,
        })}
        {renderRow({
          IconComponent: CreditCardRightSVGComponent,
          header: 'Debit card',
          price: (
            <>
              <Text textStyle="body-bold">$4.95 - $9.95</Text>
              <Text color="text.subtle">&nbsp;/ transaction*</Text>
            </>
          ),
        })}
        {renderRow({
          IconComponent: CreditCardLeftSVGComponent,
          header: 'Credit card',
          price: (
            <>
              <Text textStyle="body-bold">2.95%</Text>
              <Text color="text.subtle">&nbsp;/ transaction*</Text>
            </>
          ),
        })}
        <Text textStyle="fineprint" color="text.subtle">
          *Processing fee amounts and available payment methods vary by state.
        </Text>
      </Box>
    </Box>
  );
};

export default CostToPay;
